import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';

import { getLocale } from '../../../../configuration';
import type { RootState } from '../../../../configuration/setup/store';
import { getDescriptionOfServiceUrl } from '../../config/productConfig';
import { getTenant, type Tenant } from '../utils/tenants';

interface Props {
    tenant: Tenant;
    serviceSku: string;
    level?: string;
    locale: string;
    children: React.ReactNode;
}

const DescriptionOfService = ({ serviceSku, level, locale, children }: Props) => {
    const [show, setShow] = useState(false);
    const intl = useIntl();
    const dialogTitleId = 'marketplace.myServices.descriptionOfService.dialogTitle';
    const iframeTitle = intl.formatMessage({ id: dialogTitleId });

    return (
        <>
            <Dialog
                show={show}
                title={<FormattedMessage id={dialogTitleId} />}
                body={
                    <iframe
                        className='position-absolute top-0 left-0 width-100pct height-100pct'
                        src={getDescriptionOfServiceUrl(locale, serviceSku, level)}
                        title={iframeTitle}
                    />
                }
                onClose={() => setShow(false)}
                footer={null}
                showCloseButton={true}
                bsSize={Dialog.SIZE_FULL_SCREEN}
            />
            <span
                onClick={event => {
                    event.preventDefault();
                    setShow(true);
                }}
            >
                {children}
            </span>
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    tenant: getTenant(state),
    locale: getLocale(state),
});

export const DescriptionOfServiceContainer = connect(mapStateToProps)(DescriptionOfService);
